//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationController_updateOneById,
  Response$AdminObligationController_updateOneById$Status$200,
  ResponseContentType$AdminObligationController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminObligationController_updateOneById,
    Response$AdminObligationController_updateOneById$Status$200[ResponseContentType$AdminObligationController_updateOneById]
  >({ method: 'AdminObligationController_updateOneById' });
